export default "__VITE_ASSET__nqjyUAYr__"